// @flow

import React from 'react';

import SimplePromo from 'app/login/components/SimplePromo';

import type { SimplePromoProps } from 'app/login/components/SimplePromo';

const EducationPromo = (props: SimplePromoProps) => {
  return (
    <SimplePromo
      {...props}
      condensedContent="Set your password and claim your free education account."
      condensedIcon="info"
      imgAlt="Graduation cap with confetti surrounding it"
      imgSrc="/images/login/education-promo.svg"
      title="Almost there!"
    >
      <p>Set your password and claim your free education account.</p>
    </SimplePromo>
  );
};

export default EducationPromo;
